import * as actionTypes from '../action-types'

const initialState = {
    orgBox:[],
    labBox:[],
    roleBox:[],
    trainBox:[],
    trainlabelBox:[],
    instrumentBox:[],
    trainUserBox:[],
    labRoleBox:[],
    labUserBox:[],
    linkGroupBox:[],
    piListBox:[],
    medicineClassifyBox:[],
    medicineBrandBox:[],
    medicineUnitBox:[],
    medicineAddressBox:[],
    medicineSupplierBox:[],
    instrumentTypeBox:[],
    instrumentBrandBox:[],
    instrumentAddressBox:[],
    trainSpeakerBox:[],
    roleListBox:[],
    pisBox:[]
}

export default function selectBox (state = initialState, action={}) {
    switch (action.type) {
        case actionTypes.ORG_PUT:
            return Object.assign({},state,{orgBox:action.orgBox}); //机构下拉
        case actionTypes.LAB_PUT:
            return Object.assign({},state,{labBox:action.labBox}); //实验室下拉
        case actionTypes.GROUP_PUT:
            return Object.assign({},state,{linkGroupBox:action.linkGroupBox}); //实验室下拉
        case actionTypes.PILIST_PUT:
                return Object.assign({},state,{piListBox:action.piListBox}); //实验室下拉
        case actionTypes.ROLE_PUT:
            return Object.assign({},state,{roleBox:action.roleBox}); //用户角色下拉列表
        case actionTypes.TRAIN_PUT:
            return Object.assign({},state,{trainBox:action.trainBox}); //培训类型列表
        case actionTypes.TRAINLABEL_PUT:
            return Object.assign({},state,{trainlabelBox:action.trainlabelBox}); //培训标签列表
        case actionTypes.PERSONNELTYPE_PUT:
            return Object.assign({},state,{roleListBox:action.roleListBox}); //培训标签列表            
        case actionTypes.INSTRUMENT_PUT:
            return Object.assign({},state,{instrumentBox:action.instrumentBox});//仪器下拉
        case actionTypes.TRAINUSER_PUT:
            return Object.assign({},state,{trainUserBox:action.trainUserBox}); //培训在正常状态的备选用户
        case actionTypes.TRAIN_SPEAKER_PUT:
            return Object.assign({},state,{trainSpeakerBox:action.trainSpeakerBox}); //培训在正常状态的备选用户
        case actionTypes.TRAIN_END_USER_PUT:
            return Object.assign({},state,{trainEndUserBox:action.trainEndUserBox}); //培训主讲人（培训人）
        case actionTypes.LAB_ROLE_PUT:
            return Object.assign({},state,{labRoleBox:action.labRoleBox}); //实验室角色
        case actionTypes.LAB_USER_PUT:
            return Object.assign({},state,{labUserBox:action.labUserBox}); //实验室角色
         case actionTypes.MEDICINE_BRAND_PUT:
            return Object.assign({},state,{medicineBrandBox:action.medicineBrandBox}); //试剂耗材品牌
        case actionTypes.MEDICINE_UNIT_PUT:
            return Object.assign({},state,{medicineUnitBox:action.medicineUnitBox}); //试剂耗材单位
        case actionTypes.MEDICINE_CLASSIFY_PUT:
            return Object.assign({},state,{medicineClassifyBox:action.medicineClassifyBox}); //试剂耗材分类
        case actionTypes.MEDICINE_ADDRESS_PUT:
            return Object.assign({},state,{medicineAddressBox:action.medicineAddressBox}); //试剂耗材存放地
        case actionTypes.MEDICINE_SUPPLIER_PUT:
            return Object.assign({},state,{medicineSupplierBox:action.medicineSupplierBox}); //试剂耗材供应商
        case actionTypes.INSTRUMENT_TYPE_PUT:
            return Object.assign({},state,{instrumentTypeBox:action.instrumentTypeBox}); //设备类型
        case actionTypes.INSTRUMENT_BRAND_PUT:
            return Object.assign({},state,{instrumentBrandBox:action.instrumentBrandBox}); //设备品牌
        case actionTypes.INSTRUMENT_ADDRESS_PUT:
            return Object.assign({},state,{instrumentAddressBox:action.instrumentAddressBox}); //设备存放地
        case actionTypes.PISBOX_PUT:
            return Object.assign({},state,{pisBox:action.pisBox}); //设备存放地
            pisBox
        default:
            return state
    }
}